<template>
	<div class="version_alert">
		<div class="version_bg">
			<div class="version_wrap">
				<div class="version_close" @click="onCancelClick"></div>
				<div class="version_title">发现新版本</div>
				<div class="version_desc">
					1.优化操作界面，交互更简单；<br />
					2.修复无法访问部分路由问题；<br />
					3.提升连接性能，修复已知BUG
				</div>
				<div class="mode_btns">
					<div
						class="mode_sure_btn"
						@click="jumpDownload($store.state.app_url.windows)"
					>
						立即下载
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ["modeType"],
	methods: {
		onCancelClick: function () {
			window.external.closeWindow && window.external.closeWindow();
			// this.$emit("onCancelClick");
		},
		onSureClick: function () {
			this.$emit("onSureClick");
		},
		jumpDownload: function (url) {
			let _that = this;
			_that.$common.bridge(_that.$store.state.client).openBrowser(url);
		},
	},
};
</script>

<style lang="less" scoped>
.version_alert {
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	background-color: rgba(82, 82, 82, 0.7);
	z-index: 100;
	.version_bg {
		width: 425px;
		height: 324px;
		position: absolute;
		left: 50%;
		top: 50%;
		margin-left: -212px;
		margin-top: -162px;
		background-image: url(../../assets/common/version/bg.png);
		background-size: 100% 100%;
	}
	.version_wrap {
		width: 392px;
		height: 273px;
		position: absolute;
		left: 50%;
		top: 50%;
		margin-left: -196px;
		margin-top: -136px;
		border-radius: 5px;
		overflow: hidden;
		.version_close {
			width: 20px;
			height: 20px;
			position: absolute;
			right: 10px;
			top: 10px;
			background-image: url(../../assets/common/close4.svg);
			background-size: 100% 100%;
			cursor: pointer;
		}
		.version_close:hover {
			opacity: 0.8;
			cursor: pointer;
		}
		.version_title {
			font-size: 25px;
			color: rgba(255, 255, 255, 1);
			text-align: left;
			font-weight: bolder;
			margin-top: 40px;
			margin-left: 37px;
		}
		.version_desc {
			margin-left: 37px;
			margin-top: 65px;
			width: 236px;
			font-size: 12px;
			color: rgba(102, 102, 102, 1);
			text-align: left;
			line-height: 20px;
		}

		.mode_sure_btn {
			margin: 0 auto;
			border-radius: 20px;
			width: 128px;
			height: 40px;
			line-height: 40px;
			font-size: 12px;
			margin-top: 15px;
			font-weight: bolder;
			color: #fefefe;
			text-align: center;
			background-color: rgba(31, 93, 227, 1);
		}
		.mode_sure_btn:hover {
			opacity: 0.8;
			cursor: pointer;
		}
	}
}
</style>